import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const NumberFormatQuantite = React.forwardRef((props, ref) => {
    return (
        <NumberFormat
            {...props}
            getInputRef={ref}
            onValueChange={values => {
                props.onChange({
                    target: {
                        value: values.value
                    }
                });
            }}
            allowNegative={false}
            isNumericString
        />
    )
});

NumberFormatQuantite.displayName = "NumberFormatQuantite";

NumberFormatQuantite.propTypes = {
    // inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
};

export default NumberFormatQuantite;


